import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from 'semantic-ui-react';

import styles from '../document-modal.module.css';

const InstructionsModule = ( { document } ) => {
	return (
		<div className={ styles.formContainer }>
			<h1>{ document?.name }</h1>
			<Divider />
			{ document?.type.id === 100
				? null
				: <>
					<h3>Description</h3>
					<p>{ document?.description }</p>
					<br />
				</>
			}
			<h3>{
				document?.type.id === 100
					? 'Message'
					: 'Instructions'
			}</h3>
			<p>{ document?.introduction }</p>
		</div>
	);
};

InstructionsModule.propTypes = { document: PropTypes.object.isRequired };

export default InstructionsModule;
